import { UpdateTerminKalenderDrawerHeader } from '@/domain/termine/features/UpdateTerminkalender/Mobile/UpdateTerminKalenderDrawerHeader';
import {
  UpdateTerminKalenderFormContent,
  UpdateTerminKalenderFormContext,
  useUpdateTerminKalenderForm,
} from '@/domain/termine/features/UpdateTerminkalender/shared';

type UpdateTerminKalenderDrawerFormProps = {
  form: ReturnType<typeof useUpdateTerminKalenderForm>;
  onSubmitSuccess: () => void;
};

export function UpdateTerminKalenderDrawerForm({
  form,
  onSubmitSuccess,
}: UpdateTerminKalenderDrawerFormProps) {
  return (
    <UpdateTerminKalenderFormContext.Provider value={form}>
      <form.AppForm>
        <form
          className="flex h-full flex-col"
          onSubmit={async (e) => {
            e.preventDefault();
            await form.handleSubmit();
            onSubmitSuccess();
          }}>
          <UpdateTerminKalenderDrawerHeader />
          <div className="flex-1 overflow-y-auto overscroll-contain p-4">
            <UpdateTerminKalenderFormContent />
          </div>
        </form>
      </form.AppForm>
    </UpdateTerminKalenderFormContext.Provider>
  );
}
